<div *ngIf="messages.length" class="validation-message" role="alert" aria-live="assertive">
    <div class="validation-message__icon">!</div>

    <div class="validation-message__content">
        <h6 class="validation-message__title">{{ title }}</h6>
        <ul class="validation-message__list">
            <li *ngFor="let message of messages">{{ message }}</li>
        </ul>
    </div>

    <button *ngIf="dismissible" type="button" class="validation-message__close"
        aria-label="Close validation message" (click)="closeMessage()">
        &times;
    </button>
</div>
